export default __webpack_public_path__ + "static/media/agenda-o.453b6801.svg";